import Title from "../common/Title";
import Para from "../common/Para";
import HowItWorksCard from "./HowItWorksCard";

const HowItWorks = () => {
  return (
    <div className="sm:pt-16 pt-12 xl:pt-20">
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative">
        <Title text="How it Works ?" myClass="text-center" />
        <Para
          myClass="text-center max-w-[800px] mx-auto pt-4"
          text={`At TripNest, we make travel planning simple with an easy 4-step process. Whether you're booking a quick getaway or a full vacation, here's how you can explore the world with confidence.`}
        />
        <HowItWorksCard />
      </div>
    </div>
  );
};

export default HowItWorks;
